/**
 * Created by jv on 10/03/2017.
 */
// Styles
require("Libs/fontawesome/font-awesome.scss");
require("cookieconsent/build/cookieconsent.min.css");
require("Libs/custom-scrollbar/jquery.mCustomScrollbar.css");
require("slick-carousel/slick/slick.scss");
require("Styles/global.scss");

// js
require("Sources/misc/google-analytics");
require("babel-polyfill");
require("Libs/bootstrap/js/bootstrap");
// These libs aren't nice and put themselves in window instead of being able to be required into a variable
// prepend the JS files with 'script-loader?' to require them like they were added with ordinary <script> tags
// https://webpack.github.io/docs/shimming-modules.html
require("script-loader?Modernizr!Libs/Modernizr/modernizr-custom"); // Is used to check if browser is outdated
require("script-loader!cookieconsent/build/cookieconsent.min"); // requires the cookieconsent library like it was a script tag in the html
require("script-loader!Libs/custom-scrollbar/jquery.mCustomScrollbar.concat.min");


const LanguageManager = require("Sources/services/language-manager");
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();
const Dialog = require("Sources/utils/modal");

const slick = require("slick-carousel/slick/slick");

var Shared = {};

((Shared) =>
{
  Shared.init = function()
  {
    if(Shared.isOutdated())
    {
      log.info("Browser is outdated, redirecting to /outdated");
      utils.redirect("/outdated");
    }

    setUpFragmentImages();

    LanguageManager.init();

    setUpLocalizedResources();

  };

  LanguageManager.onInitGlobal = function()
  {
    try
    {
      cookieconsent.initialise({
        palette: {
          popup: {
            background: "#946331",
            text: "#fff9eb"
          },
          button: {
            background: "#fff9eb",
            text: "#946331"
          }
        },
        theme: "classic",
        content: {
          message: LanguageManager.getValueForKey("cookies.message"),
          dismiss: LanguageManager.getValueForKey("cookies.button.text"),
          link: LanguageManager.getValueForKey("cookies.link.text"),
          href: LanguageManager.getValueForKey("cookies.link")
        }
      });
    }
    catch(e)
    {
      console.error(e);
    }

    $(".language-selector a").removeClass("active");
    $(".language-selector a[data-locale-active='" + LanguageManager.getCurrentLocale() + "']").addClass("active");

  };


  Shared.isOutdated = function()
  {
    return !Modernizr.filereader;
  };

  function setUpFragmentImages()
  {
    var headerNLLogo = require("Images/logo_boerdereis_nl.png");
    var headerFRLogo = require("Images/logo_boerdereis_fr.png");
    var footerLogo = require("Images/logo_delhaize_small.png");

    $(".navbar-brand.mx-auto").append("<img src='" + headerNLLogo + "' data-locale='nl-BE'/>");
    $(".navbar-brand.mx-auto").append("<img src='" + headerFRLogo + "' data-locale='fr-BE'/>");

    $(".footer-logo").append("<a href='https://www.delhaize.be' target='_blank'><img src='" + footerLogo + "'/></a>");
  }

  // a tag is added in localization - this needs to be called after LanguageManager.init()
  function setUpLocalizedResources()
  {
    var eulaNL = require("Data/gebruiksvoorwaarden_website_07062018.pdf");
    var eulaFR = require("Data/Gebruiksvoorwaarden_Website_FR.pdf");

    var rulesNl = require("Data/competition-rules/rules_nl.pdf");
    var rulesFr = require("Data/competition-rules/rules_fr.pdf");

    $("#eula_nl-BE a").attr("href", eulaNL);
    $("#eula_fr-BE a").attr("href", eulaFR);

    $("#competition-rules_nl-BE a").attr("href", rulesNl);
    $("#competition-rules_fr-BE a").attr("href", rulesFr);
  }

  Shared.Dialog = Dialog;
})(Shared);

(() =>
{
  "use strict"

  if (navigator.userAgent.match(/IEMobile\/10\.0/))
  {
    var msViewportStyle = document.createElement("style")
    msViewportStyle.appendChild(
      document.createTextNode(
        "@-ms-viewport{width:auto!important}"
      )
    )
    document.head.appendChild(msViewportStyle)
  }
})();

module.exports = Shared;


/* add referrer to language selector*/
$(".language-selector-wrapper a").each(function(){
  var link = $(this); // %TODO: referer meteen zetten op fr of nl domein
  link.attr("href", link.attr("href") + "&referer=" + window.location.pathname.substring(6));
});

$(".language-selector-menu li a").each(function(){
  var link = $(this); // %TODO: referer meteen zetten op fr of nl domein
  link.attr("href", link.attr("href") + "&referer=" + window.location.pathname.substring(6));
});




// WEBPACK FOOTER //
// ./app/js/shared.js